import React from "react"
import AsyncSelect from "react-select/async"
import { useDispatch } from "react-redux"
import {
  getCajaAlumnos as onGetAlumnos,
  CampusVirtual_WaitForPropertyToChange,
} from "../../store/actions"

const AsyncAlumnosSelect = ({
  value,
  defaultOptions,
  idCampus,
  handlerOptionSelected,
}) => {
  //
  let debounceTimer
  //
  const dispatch = useDispatch()

  const loadOptions = inputValue =>
    new Promise(resolve => {
      waitForChange("Caja.context.alumnos").then(newAlumnos => {
        resolve(newAlumnos)
      })
    })

  const waitForChange = property => {
    return new Promise(resolve => {
      dispatch(CampusVirtual_WaitForPropertyToChange(property, resolve))
    })
  }

  const handleInputChange = stringBusqueda => {
    clearTimeout(debounceTimer)

    if (stringBusqueda?.length > 4) {
      debounceTimer = setTimeout(() => {
        dispatch(
          onGetAlumnos({
            nombreSolicitud: "listaalumnosxnombre_xidcampus",
            idCampus: idCampus,
            stringBusqueda: stringBusqueda,
          })
        )
      }, 500) // Espera 500 ms antes de despachar la acción
    }
  }

  return (
    <AsyncSelect
      cacheOptions
      value={value}
      defaultOptions={defaultOptions}
      loadOptions={loadOptions}
      onInputChange={handleInputChange}
      onChange={handlerOptionSelected}
      placeholder="Buscar alumno..."
    />
  )
}

export default AsyncAlumnosSelect
